import React from 'react'
import './noticelinks.scss'
import { Link, useLocation } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap';

const NoticeLinks = () => {
    const location = useLocation();
    const pageTitles = {
        '/footer/customer-notifications': 'Customer notifications',
        '/footer/legal-disclaimer': 'Legal disclaimer',
        '/privacy': 'Privacy',
        '/sitemap': 'Sitemap',
        '/terms-and-conditions': 'Terms and conditions',
        '/footer/web-accessibility': 'Web accessibility',
    };

    const activePageTitle = pageTitles[location.pathname] || 'Select a page';
    return (
        <div className='notice-links'>
            <div className='blue-wrapper'>
                <div className='notice-heading'>
                    <h2>Notices</h2>
                </div>
                <div className='dropdown-container d-md-none d-block'>
                    <Dropdown>
                        <Dropdown.Toggle id="dropdown-basic">  {activePageTitle}</Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to="/footer/customer-notifications">Customer notifications</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/footer/legal-disclaimer">Legal disclaimer</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/privacy">Privacy</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/sitemap">Sitemap</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/terms-and-conditions">Terms and conditions</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/footer/web-accessibility">Web accessibility</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className='tabs-container d-none d-md-block'>
                    <div className='lists'>
                        <ul>
                            <li className={`${location.pathname === '/footer/customer-notifications' ? 'active' : ''}`}>
                                <Link to='/footer/customer-notifications'>Customer notifications</Link></li>
                            <li className={`${location.pathname === '/footer/legal-disclaimer' ? 'active' : ''}`}    >
                                <Link to='/footer/legal-disclaimer'>Legal disclaimer</Link></li>
                            <li><Link to='/privacy'>Privacy</Link></li>
                            <li><Link to='/sitemap'>Sitemap</Link></li>
                            <li className={`${location.pathname === '/terms-and-conditions' ? 'active' : ''}`}>
                                <Link to='/terms-and-conditions'>Terms and conditions</Link></li>
                            <li className={`${location.pathname === '/footer/web-accessibility' ? 'active' : ''}`}>
                                <Link to='/footer/web-accessibility'>Web accessibility</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NoticeLinks